var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("div", { staticClass: "styles-result-header" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["site.search.collection.result.header"]) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row w-100" },
      [
        _vm._l(_vm.collections.slice(0, 4), function(collection) {
          return collection.itemsCount > 0
            ? _c("div", { key: collection.code, staticClass: "col-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "wf-search-result description search-collection-height w-100 p-0 mb-1"
                  },
                  [
                    _c("div", { staticClass: "wf-search-result-top mb-0" }, [
                      _c(
                        "div",
                        { staticClass: "wf-search-result-image-wrapper" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-decoration-none",
                              attrs: {
                                href: _vm.$helpers.getCollectionOverviewUrl(
                                  _vm.getCollectionLink(collection)
                                )
                              }
                            },
                            [
                              _c("wf-load-image", {
                                attrs: {
                                  wrapperClass: "wf-search-result-image d-flex",
                                  imageClass: "image full-image",
                                  src:
                                    collection.imagePath != null
                                      ? collection.imagePath
                                      : "",
                                  alt: collection.imagePathAltText || "",
                                  noImageStyles: "no-image-style-block"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "styles-list" }, [
                      _c("li", {
                        staticClass: "mb-0",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$helpers.matchText(
                              collection.name,
                              _vm.searchTerm
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(collection.itemsCount) +
                            "\n            " +
                            _vm._s(
                              _vm.$resourceString[
                                "site.search.products.result.style.list"
                              ]
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-auto pt-2" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "view-styles-link",
                            attrs: {
                              href: _vm.$helpers.getCollectionOverviewUrl(
                                _vm.getCollectionLink(collection)
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "site.search.products.result.see.collection"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("Icon", {
                          staticClass: "mb-1",
                          attrs: { icon: "bx:bx-right-arrow-alt", width: "15" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _vm.collections.length > 4
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.$helpers.getSearchTermUrl(
                      _vm.searchTerm,
                      "collections"
                    )
                  }
                },
                [
                  _c("div", { staticClass: "view-more" }, [
                    _c(
                      "div",
                      { staticClass: "view-more-text" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$resourceString[
                                "site.search.products.result.view.more"
                              ]
                            ) +
                            "\n            "
                        ),
                        _c("Icon", {
                          staticClass: "pb-1 pl-1",
                          attrs: {
                            icon: "fa-solid:plus",
                            color: "white",
                            width: "20"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }